/*
 *  -----------------------------------------------------------------------
 *    <copyright file="verify-email.tsx" company="Triumph Research Intelligence">
 *        Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *    </copyright>
 *   -----------------------------------------------------------------------
 *
 */

import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { UserContext } from 'contexts/user-context';
import Settings from 'settings/settings';
import { AllRoutes } from '@utils/router/all-routes';

const VerifyEmailAddress = () => {
    const navigate = useNavigate();
    const { organisationKey, userId } = useParams();
    const [error, setError] = useState(null);
    const { setUser, setToken } = useContext(UserContext);

    useEffect(() => {
        setUser(null);
        setToken(null);
    }, []);

    useEffect(() => {
        fetch(`${Settings.api.url()}/api/verify-email/${organisationKey}/${userId}`)
            .then((result: any) => {
                if (result.status === 200)
                    result
                        .text()
                        .then((orgCode: string) =>
                            navigate(
                                orgCode
                                    ? `${AllRoutes.path('login-organisation', { orgCode })}?verified=true`
                                    : `${AllRoutes.path('login')}?verified=true`,
                            ),
                        );
                else setError(result.status);
            })
            .catch(({ message }: { message: string }) => {
                setError(message);
            });
    }, []);

    return error ? <div>{error}</div> : null;
};

export default VerifyEmailAddress;
